<template>
    <ui-field :label="label" :name="name" :error="error" :warning="warning" :info="info">
        <div class="border border-gray-200 rounded-md text-sm">
            <table class="w-full">
                <tbody class="divide-y divide-gray-200">
                    <tr v-for="(material, index) in value" :key="`${material.id}_${index}`">
                        <td class="px-4 py-3 align-middle break-words">
                            <ui-select-searchable
                                label="Material"
                                :value="material"
                                :search="searchMaterials"
                                option-label="name"
                                :hideChevron="true"
                                no-search="Type to search materials..."
                                @input="newMaterial => updateMaterial(material, newMaterial, material.quantity)"
                                :create-option="name => createMaterialOnDemand(name)"
                            ></ui-select-searchable>
                        </td>
                        <td class="px-4 py-3 align-middle whitespace-nowrap w-px">
                            <ui-input
                                label="Quantity"
                                type="number"
                                :value="material.quantity"
                                @input="newQuantity => updateMaterial(material, material, newQuantity)"
                            ></ui-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="px-4 py-3 align-middle break-words bg-gray-50 rounded-br-md" :class="{ 'rounded-tr-md': ! value || value.length === 0 }">
                            <ui-select-searchable
                                key="adding"
                                label="Material"
                                v-model="material"
                                :search="searchMaterials"
                                option-label="name"
                                :hideChevron="true"
                                no-search="Type to search materials..."
                                :create-option="name => createMaterialOnDemand(name)"
                                @input="addMaterial"
                            ></ui-select-searchable>
                        </td>
                        <td class="px-4 py-3 align-middle whitespace-nowrap w-32 bg-gray-50 rounded-bl-md" :class="{ 'rounded-tl-md': ! value || value.length === 0 }">
                            <ui-input v-model="quantity" type="number" label="Quantity"></ui-input>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ui-field>
</template>

<script>
import { Material } from '@models'
import { uuid } from '@utils'

export default {
    props: {
        value: Array,
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
    },
    data () {
        return {
            quantity: 0,
            material: null,
        }
    },
    methods: {
        async searchMaterials (search) {
            return await Material.search(search, true)
        },
        createMaterialOnDemand (name) {
            const temporaryId = uuid()
            const newMaterial = { name, id: temporaryId, quantity: 0 }

            // Update with the real id when request is over.
            Material.create({ name }).then(async createdMaterial => {
                const materials = (this.value || []).map(item => {
                    if (item.id !== temporaryId) return item
                    item.id = createdMaterial.id
                    return item
                }) 
                this.$emit('input', materials)
            })

            return newMaterial
        },
        updateMaterial (material, newMaterial, newQuantity) {
            if (! newMaterial) return this.removeMaterial(material)
            const materials = (this.value || []).map(item => {
                if (item !== material) return item
                return {
                    id: newMaterial.id,
                    name: newMaterial.name,
                    quantity: newQuantity,
                }
            }) 
            this.$emit('input', materials)
        },
        removeMaterial (material) {
            const materials = this.value || []
            this.$emit('input', materials.filter(item => item !== material))
        },
        addMaterial () {
            if (! this.material) {
                return;
            }

            const materials = this.value || []
            materials.push({
                id: this.material.id,
                name: this.material.name,
                quantity: this.quantity,
            })

            this.$emit('input', materials)

            this.$nextTick(() => {
                this.quantity = 0
                this.material = null
            })
        },
    },
}
</script>
